var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgJoinOrTwo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 30,
    viewBox: "0 0 42 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.9981 27.4267C25.3236 25.1401 28.2713 20.5954 28.2713 15.3622C28.2713 10.1289 25.3236 5.58417 20.9981 3.29759C16.6725 5.58417 13.7248 10.1289 13.7248 15.3622C13.7248 20.5954 16.6725 25.1401 20.9981 27.4267Z",
    fill: "#00A8B8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21 27.4267C25.3255 25.1402 28.2732 20.5954 28.2732 15.3622C28.2732 10.129 25.3255 5.5842 21 3.29763C22.8999 2.29329 25.0657 1.72461 27.3643 1.72461C34.8961 1.72461 41.0019 7.83036 41.0019 15.3622C41.0019 22.894 34.8961 28.9998 27.3643 28.9998C25.0657 28.9998 22.8999 28.4311 21 27.4267Z",
    fill: "#00A8B8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21 3.29763C16.6742 5.58417 13.7267 10.1291 13.7267 15.3624C13.7267 20.5956 16.6745 25.1401 21 27.4267C19.1001 28.431 16.9341 28.9998 14.6356 28.9998C7.1038 28.9998 0.998047 22.894 0.998047 15.3622C0.998047 7.83036 7.1038 1.72461 14.6356 1.72461C16.9343 1.72461 19.1 2.29321 21 3.29763Z",
    fill: "#00A8B8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21 27.4267C25.3255 25.1402 28.2732 20.5954 28.2732 15.3622C28.2732 10.129 25.3255 5.5842 21 3.29763M21 27.4267C22.8999 28.4311 25.0657 28.9998 27.3643 28.9998C34.8961 28.9998 41.0019 22.894 41.0019 15.3622C41.0019 7.83036 34.8961 1.72461 27.3643 1.72461C25.0657 1.72461 22.8999 2.29329 21 3.29763M21 27.4267C16.6745 25.1401 13.7267 20.5956 13.7267 15.3624C13.7267 10.1291 16.6742 5.58417 21 3.29763M21 27.4267C19.1001 28.431 16.9341 28.9998 14.6356 28.9998C7.1038 28.9998 0.998047 22.894 0.998047 15.3622C0.998047 7.83036 7.1038 1.72461 14.6356 1.72461C16.9343 1.72461 19.1 2.29321 21 3.29763M28.2713 15.3622C28.2713 20.5954 25.3236 25.1401 20.9981 27.4267C16.6725 25.1401 13.7248 20.5954 13.7248 15.3622C13.7248 10.1289 16.6725 5.58417 20.9981 3.29759C25.3236 5.58417 28.2713 10.1289 28.2713 15.3622Z",
    stroke: "white",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJoinOrTwo);
export default __webpack_public_path__ + "static/media/join-or-two.2691c8b064f9d647b3522c47606d125c.svg";
export { ForwardRef as ReactComponent };